import React, {useRef} from 'react';

import {skipToken} from '@reduxjs/toolkit/query';
import {browserHistory, WithRouterProps} from 'react-router';

import {
  useAnswerQuestion,
  useAttempt,
  useCompleteAttempt,
  useQuiz,
} from 'app/quizzes/api';
import {AttemptQuizContent} from 'app/quizzes/components/AttemptQuizPage/AttemptQuizContent';
import {TakeQuizPage} from 'app/quizzes/components/TakeQuizPage/TakeQuizPage';

import type {AttemptAnswerType, QuestionType} from 'sweet-types';

type Props = WithRouterProps<{
  hashid: string;
  versionid: null | string;
  attemptid?: string;
}>;

export function AttemptQuizPage({params}: Props) {
  const {attemptid: attemptId, versionid: versionId, hashid} = params;
  const {data: attempt} = useAttempt(attemptId != null ? attemptId : skipToken);
  const {data: quiz} = useQuiz(
    attempt?.quiz != null ? (attempt.quiz.id as unknown as string) : skipToken
  );
  const [completeAttempt, {isLoading: isSubmitting}] = useCompleteAttempt();
  const [answerQuestion, {isLoading: isAnsweringQuestion}] =
    useAnswerQuestion();
  const dateCreateAt = useRef<string>('');

  if (attempt == null) return null;

  dateCreateAt.current = attempt.created_at;

  const handleAnswerQuestion = ({
    question,
    answer,
  }: {
    answer: AttemptAnswerType;
    question: QuestionType;
  }) => {
    answerQuestion({
      question_id: question.id,
      attempt_id: attempt.id,
      ...answer,
    });
  };

  const handleSubmitAttempt = () => {
    completeAttempt({
      attempt,
    })
      .unwrap()
      .then(() => {
        browserHistory.push(`${attempt.take_url}result/`);
      });
  };

  return (
    <TakeQuizPage versionId={versionId} hashid={hashid} attemptId={attemptId}>
      <AttemptQuizContent
        attempt={attempt}
        content={quiz?.content}
        duration={quiz?.duration ?? undefined}
        onAnswer={handleAnswerQuestion}
        onSubmitAttempt={handleSubmitAttempt}
        isSubmitting={isSubmitting}
        isAnsweringQuestion={isAnsweringQuestion}
      />
    </TakeQuizPage>
  );
}
